module.exports = __webpack_public_path__ + "img/semicircle-bottom.c9f7e844.svg";